(function () {
  function setMerchMenuActive() {
    const merchMenu = document.querySelector('#MainContent .jamersan--header');
    const mainMenuMerchLink = document.querySelector('#HeaderMenu-merch');

    if (merchMenu && mainMenuMerchLink) {
      const span = mainMenuMerchLink.querySelector('span');
      if (span && !span.classList.contains('header__active-menu-item')) {
        span.classList.add('header__active-menu-item');
      }
    }
  }

  function init() {
    setMerchMenuActive();

    // Observe DOM changes (Shopify sections, AJAX navigation, etc.)
    const observer = new MutationObserver(() => {
      setMerchMenuActive();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
